<div class="p-15">
    <h2 mat-dialog-title style="text-align: center">{{ "EXPORT.DIALOG.title" | translate }}</h2>
    <div>{{ "EXPORT.DIALOG.description" | translate }}</div>
    <div>{{ "EXPORT.DIALOG.descriptionConfirm" | translate }}</div>
    <mat-dialog-actions style="justify-content: space-between" class="p-2">
        <button mat-raised-button color="warn" style="width: 100px" [mat-dialog-close]="false" cdkFocusInitial>
            {{ "GENERAL.cancel" | translate }}
        </button>
        <button mat-raised-button color="primary" style="width: 100px" [mat-dialog-close]="true">Export</button>
    </mat-dialog-actions>
</div>
